document.addEventListener('DOMContentLoaded', function() {
    var triggers = document.querySelectorAll('.hover-trigger');
    var allContent = document.querySelectorAll('.discover-ayurveda__right');
    var allSubtitles = document.querySelectorAll('.discover-ayurveda__subtitle');
    var stepTriggers = document.querySelectorAll('.accordion-trigger');
    var sliderTrack = document.querySelector('.discover-ayurveda__slider-track');
    var sliderSection = document.getElementById('discover-ayurveda-section');

    function isMobile() {
        return window.innerWidth <= 1121;
    }

    function isSliderMode() {
        return window.innerWidth <= 1122;
    }

    function syncToSlide(index) {
        var i = Math.max(0, Math.min(index, allContent.length - 1));
        allContent.forEach(function(el, j) { el.classList.toggle('active', j === i); });
        allSubtitles.forEach(function(el, j) { el.classList.toggle('active', j === i); });
        stepTriggers.forEach(function(el, j) { el.classList.toggle('active', j === i); });
    }

    function initSlickSlider() {
        if (typeof jQuery === 'undefined' || typeof jQuery.fn.slick === 'undefined') {
            setTimeout(initSlickSlider, 100);
            return;
        }
        if (!sliderTrack || !sliderSection) return;
        var $track = jQuery(sliderTrack);
        if ($track.hasClass('slick-initialized')) return;
        if (!isSliderMode()) return;

        $track.on('init', function(event, slick) {
            syncToSlide(slick.currentSlide);
        });
        $track.on('afterChange', function(event, slick, currentSlide) {
            syncToSlide(currentSlide);
        });

        $track.slick({
            centerMode: true,
            centerPadding: '12%',
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            speed: 600,
            cssEase: 'cubic-bezier(0.4, 0, 0.2, 1)',
            prevArrow: sliderSection.querySelector('.discover-ayurveda__slider-prev'),
            nextArrow: sliderSection.querySelector('.discover-ayurveda__slider-next'),
            dots: false
        });
    }

    function destroySlickSlider() {
        if (typeof jQuery === 'undefined' || !sliderTrack) return;
        var $track = jQuery(sliderTrack);
        if ($track.hasClass('slick-initialized')) {
            $track.slick('unslick');
        }
    }

    function handleResize() {
        if (isSliderMode()) {
            if (!jQuery(sliderTrack).hasClass('slick-initialized')) {
                initSlickSlider();
            }
        } else {
            destroySlickSlider();
        }
    }

    allContent.forEach(function(content, index) {
        if (index !== 0) content.classList.remove('active');
    });
    allSubtitles.forEach(function(subtitle, index) {
        if (index !== 0) subtitle.classList.remove('active');
    });

    triggers.forEach(function(trigger) {
        trigger.addEventListener('mouseenter', function() {
            if (isMobile()) return;
            stepTriggers.forEach(function(t) { t.classList.remove('active'); });
            this.classList.add('active');
            var targetId = this.getAttribute('data-target');
            var stepNumber = this.getAttribute('data-step');
            var subtitleId = 'step-subtitle-' + stepNumber;
            allContent.forEach(function(c) { c.classList.remove('active'); });
            allSubtitles.forEach(function(s) { s.classList.remove('active'); });
            var targetContent = document.getElementById(targetId);
            if (targetContent) targetContent.classList.add('active');
            var targetSubtitle = document.getElementById(subtitleId);
            if (targetSubtitle) targetSubtitle.classList.add('active');
        });
    });

    stepTriggers.forEach(function(trigger) {
        trigger.addEventListener('click', function() {
            stepTriggers.forEach(function(t) { t.classList.remove('active'); });
            this.classList.add('active');
            var targetId = this.getAttribute('data-target');
            var step = this.getAttribute('data-step');
            allContent.forEach(function(c) { c.classList.remove('active'); });
            var targetContent = document.getElementById(targetId);
            if (targetContent) targetContent.classList.add('active');
            allSubtitles.forEach(function(s, i) { s.classList.toggle('active', String(i + 1) === step); });
            if (isSliderMode() && typeof jQuery !== 'undefined' && jQuery(sliderTrack).hasClass('slick-initialized')) {
                jQuery(sliderTrack).slick('slickGoTo', parseInt(step, 10) - 1);
            }
        });
    });

    function setRightColumnMinHeight() {
        if (isMobile() || !allContent.length) return;
        var maxHeight = 0;
        for (var i = 0; i < allContent.length; i++) {
            allContent.forEach(function(el, j) {
                el.style.display = j === i ? 'flex' : 'none';
            });
            var h = allContent[i].offsetHeight;
            if (h > maxHeight) maxHeight = h;
        }
        var heightToApply = Math.max(0, maxHeight - 30);
        allContent.forEach(function(el) {
            el.style.minHeight = heightToApply + 'px';
            el.style.display = '';
        });
    }

    setRightColumnMinHeight();

    if (isSliderMode()) {
        initSlickSlider();
    }

    var resizeTimer;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
            if (isMobile()) {
                allContent.forEach(function(el) { el.style.minHeight = ''; });
            } else {
                setRightColumnMinHeight();
            }
            handleResize();
        }, 250);
    });
});
